/**
 * Responsive design breapoints
 */
const breakpoints = {
  xs: 0, // mobile
  sm: 600, // big mobile
  md: 900, // tablet
  lg: 1200, // small screen
  xl: 1740, // hi-res screen
};

export default breakpoints;
